import { createSlice } from '@reduxjs/toolkit';
import { createIndependentStore } from '@utils/react';

const initialState = {
  app: void 0,
  publisher: "gyldendal",
  authors: void 0,
  product: void 0,
  page: void 0,
  course: void 0
};
const slice = createSlice({
  name: "provider/app-context",
  initialState,
  reducers: {
    init(state, action) {
      state.app = action.payload.app;
      state.publisher = action.payload.publisher;
      state.product = action.payload.product;
      if (action.payload.page) {
        state.page = action.payload.page;
      }
      if (action.payload.course) {
        state.course = action.payload.course;
      }
    },
    update(state, action) {
      state.page = action.payload.page;
      state.course = action.payload.course;
    },
    setAuthors(state, action) {
      state.authors = action.payload;
    }
  }
});
const appContextStore = createIndependentStore(slice);
const useAppContext = appContextStore.useSelector;

export { appContextStore, slice, useAppContext };
//# sourceMappingURL=app-context.state.js.map
